module.exports = __webpack_public_path__ + "static/media/trivuj aakr ko bastu.14685571.wav";